import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'

const _0e433b93 = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _23a72e48 = () => interopDefault(import('../pages/biometry/index.vue' /* webpackChunkName: "pages/biometry/index" */))
const _e64111b4 = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _4c92363e = () => interopDefault(import('../pages/documents.vue' /* webpackChunkName: "pages/documents" */))
const _ca324bc8 = () => interopDefault(import('../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _1695ccf0 = () => interopDefault(import('../pages/iban.vue' /* webpackChunkName: "pages/iban" */))
const _042b544c = () => interopDefault(import('../pages/loan.vue' /* webpackChunkName: "pages/loan" */))
const _10ba8d22 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _455a88bd = () => interopDefault(import('../pages/offices.vue' /* webpackChunkName: "pages/offices" */))
const _4bb7511c = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _37fbcd6d = () => interopDefault(import('../pages/recover/index.vue' /* webpackChunkName: "pages/recover/index" */))
const _317de59b = () => interopDefault(import('../pages/repay.vue' /* webpackChunkName: "pages/repay" */))
const _bafb3120 = () => interopDefault(import('../pages/application/accepted.vue' /* webpackChunkName: "pages/application/accepted" */))
const _48149816 = () => interopDefault(import('../pages/application/apply.vue' /* webpackChunkName: "pages/application/apply" */))
const _dddc7c6c = () => interopDefault(import('../pages/application/change-iban.vue' /* webpackChunkName: "pages/application/change-iban" */))
const _55b5fb03 = () => interopDefault(import('../pages/application/loading.vue' /* webpackChunkName: "pages/application/loading" */))
const _68d5b83a = () => interopDefault(import('../pages/application/offer.vue' /* webpackChunkName: "pages/application/offer" */))
const _c49590c8 = () => interopDefault(import('../pages/application/offer-increase.vue' /* webpackChunkName: "pages/application/offer-increase" */))
const _92aace72 = () => interopDefault(import('../pages/application/rejected.vue' /* webpackChunkName: "pages/application/rejected" */))
const _90b9bb9c = () => interopDefault(import('../pages/biometry/loading.vue' /* webpackChunkName: "pages/biometry/loading" */))
const _db3b5110 = () => interopDefault(import('../pages/biometry/rejected.vue' /* webpackChunkName: "pages/biometry/rejected" */))
const _19150568 = () => interopDefault(import('../pages/card/accepted.vue' /* webpackChunkName: "pages/card/accepted" */))
const _cc24c014 = () => interopDefault(import('../pages/card/offline-accepted.vue' /* webpackChunkName: "pages/card/offline-accepted" */))
const _a3d45d66 = () => interopDefault(import('../pages/card/offline-rejected.vue' /* webpackChunkName: "pages/card/offline-rejected" */))
const _079daea3 = () => interopDefault(import('../pages/card/rejected.vue' /* webpackChunkName: "pages/card/rejected" */))
const _7d7cc1b8 = () => interopDefault(import('../pages/profile/change-password.vue' /* webpackChunkName: "pages/profile/change-password" */))
const _9b53d4cc = () => interopDefault(import('../pages/profile/edit.vue' /* webpackChunkName: "pages/profile/edit" */))
const _f856df78 = () => interopDefault(import('../pages/profile/legal-documents.vue' /* webpackChunkName: "pages/profile/legal-documents" */))
const _2bf9a991 = () => interopDefault(import('../pages/profile/my-loan.vue' /* webpackChunkName: "pages/profile/my-loan" */))
const _35fff11c = () => interopDefault(import('../pages/profile/no-loan.vue' /* webpackChunkName: "pages/profile/no-loan" */))
const _80e6780e = () => interopDefault(import('../pages/registration/step1.vue' /* webpackChunkName: "pages/registration/step1" */))
const _80ca490c = () => interopDefault(import('../pages/registration/step2.vue' /* webpackChunkName: "pages/registration/step2" */))
const _80ae1a0a = () => interopDefault(import('../pages/registration/step3.vue' /* webpackChunkName: "pages/registration/step3" */))
const _8091eb08 = () => interopDefault(import('../pages/registration/step4.vue' /* webpackChunkName: "pages/registration/step4" */))
const _7ee082c6 = () => interopDefault(import('../pages/registration/upload.vue' /* webpackChunkName: "pages/registration/upload" */))
const _36452c25 = () => interopDefault(import('../pages/recover/_slug.vue' /* webpackChunkName: "pages/recover/_slug" */))
const _0745b249 = () => interopDefault(import('../pages/special-campaign/_slug.vue' /* webpackChunkName: "pages/special-campaign/_slug" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _36f9fd41 = () => interopDefault(import('../app/modules/processing/ui/pages/hesab-payment.vue' /* webpackChunkName: "" */))
const _145528fa = () => interopDefault(import('../app/modules/processing/ui/pages/epoint-payment.vue' /* webpackChunkName: "" */))
const _013f1734 = () => interopDefault(import('../app/modules/processing/ui/pages/accepted.vue' /* webpackChunkName: "" */))
const _1388a5bd = () => interopDefault(import('../app/modules/processing/ui/pages/rejected.vue' /* webpackChunkName: "" */))
const _59ba53f2 = () => interopDefault(import('../node_modules/@sf/core/pages/flow.vue' /* webpackChunkName: "" */))
const _943633aa = () => interopDefault(import('../node_modules/@sf/core/admin/login.vue' /* webpackChunkName: "" */))
const _ae311c12 = () => interopDefault(import('../node_modules/@sf/core/admin/router.vue' /* webpackChunkName: "" */))

Vue.use(Router)

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'

    // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.
    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto'
    })

    // Setting scrollRestoration to manual again when returning to this page.
    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual'
    })
  }
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected and scrollToTop is not explicitly disabled
  if (
    to.matched.length < 2 &&
    to.matched.every(r => r.components.default.options.scrollToTop !== false)
  ) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise((resolve) => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'active-url',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,

    routes: [{
      path: "/about",
      component: _0e433b93,
      name: "about___az"
    }, {
      path: "/ru/about",
      component: _0e433b93,
      name: "about___ru"
    }, {
      path: "/biometry",
      component: _23a72e48,
      name: "biometry___az"
    }, {
      path: "/ru/biometry",
      component: _23a72e48,
      name: "biometry___ru"
    }, {
      path: "/contact",
      component: _e64111b4,
      name: "contact___az"
    }, {
      path: "/ru/contact",
      component: _e64111b4,
      name: "contact___ru"
    }, {
      path: "/documents",
      component: _4c92363e,
      name: "documents___az"
    }, {
      path: "/ru/documents",
      component: _4c92363e,
      name: "documents___ru"
    }, {
      path: "/faq",
      component: _ca324bc8,
      name: "faq___az"
    }, {
      path: "/ru/faq",
      component: _ca324bc8,
      name: "faq___ru"
    }, {
      path: "/iban",
      component: _1695ccf0,
      name: "iban___az"
    }, {
      path: "/ru/iban",
      component: _1695ccf0,
      name: "iban___ru"
    }, {
      path: "/loan",
      component: _042b544c,
      name: "loan___az"
    }, {
      path: "/ru/loan",
      component: _042b544c,
      name: "loan___ru"
    }, {
      path: "/login",
      component: _10ba8d22,
      name: "login___az"
    }, {
      path: "/ru/login",
      component: _10ba8d22,
      name: "login___ru"
    }, {
      path: "/offices",
      component: _455a88bd,
      name: "offices___az"
    }, {
      path: "/ru/offices",
      component: _455a88bd,
      name: "offices___ru"
    }, {
      path: "/profile",
      component: _4bb7511c,
      name: "profile___az"
    }, {
      path: "/ru/profile",
      component: _4bb7511c,
      name: "profile___ru"
    }, {
      path: "/recover",
      component: _37fbcd6d,
      name: "recover___az"
    }, {
      path: "/ru/recover",
      component: _37fbcd6d,
      name: "recover___ru"
    }, {
      path: "/repay",
      component: _317de59b,
      name: "repay___az"
    }, {
      path: "/ru/repay",
      component: _317de59b,
      name: "repay___ru"
    }, {
      path: "/application/accepted",
      component: _bafb3120,
      name: "application-accepted___az"
    }, {
      path: "/ru/application/accepted",
      component: _bafb3120,
      name: "application-accepted___ru"
    }, {
      path: "/application/apply",
      component: _48149816,
      name: "application-apply___az"
    }, {
      path: "/ru/application/apply",
      component: _48149816,
      name: "application-apply___ru"
    }, {
      path: "/application/change-iban",
      component: _dddc7c6c,
      name: "application-change-iban___az"
    }, {
      path: "/ru/application/change-iban",
      component: _dddc7c6c,
      name: "application-change-iban___ru"
    }, {
      path: "/application/loading",
      component: _55b5fb03,
      name: "application-loading___az"
    }, {
      path: "/ru/application/loading",
      component: _55b5fb03,
      name: "application-loading___ru"
    }, {
      path: "/application/offer",
      component: _68d5b83a,
      name: "application-offer___az"
    }, {
      path: "/ru/application/offer",
      component: _68d5b83a,
      name: "application-offer___ru"
    }, {
      path: "/application/offer-increase",
      component: _c49590c8,
      name: "application-offer-increase___az"
    }, {
      path: "/ru/application/offer-increase",
      component: _c49590c8,
      name: "application-offer-increase___ru"
    }, {
      path: "/application/rejected",
      component: _92aace72,
      name: "application-rejected___az"
    }, {
      path: "/ru/application/rejected",
      component: _92aace72,
      name: "application-rejected___ru"
    }, {
      path: "/biometry/loading",
      component: _90b9bb9c,
      name: "biometry-loading___az"
    }, {
      path: "/ru/biometry/loading",
      component: _90b9bb9c,
      name: "biometry-loading___ru"
    }, {
      path: "/biometry/rejected",
      component: _db3b5110,
      name: "biometry-rejected___az"
    }, {
      path: "/ru/biometry/rejected",
      component: _db3b5110,
      name: "biometry-rejected___ru"
    }, {
      path: "/card/accepted",
      component: _19150568,
      name: "card-accepted___az"
    }, {
      path: "/ru/card/accepted",
      component: _19150568,
      name: "card-accepted___ru"
    }, {
      path: "/card/offline-accepted",
      component: _cc24c014,
      name: "card-offline-accepted___az"
    }, {
      path: "/ru/card/offline-accepted",
      component: _cc24c014,
      name: "card-offline-accepted___ru"
    }, {
      path: "/card/offline-rejected",
      component: _a3d45d66,
      name: "card-offline-rejected___az"
    }, {
      path: "/ru/card/offline-rejected",
      component: _a3d45d66,
      name: "card-offline-rejected___ru"
    }, {
      path: "/card/rejected",
      component: _079daea3,
      name: "card-rejected___az"
    }, {
      path: "/ru/card/rejected",
      component: _079daea3,
      name: "card-rejected___ru"
    }, {
      path: "/profile/change-password",
      component: _7d7cc1b8,
      name: "profile-change-password___az"
    }, {
      path: "/ru/profile/change-password",
      component: _7d7cc1b8,
      name: "profile-change-password___ru"
    }, {
      path: "/profile/edit",
      component: _9b53d4cc,
      name: "profile-edit___az"
    }, {
      path: "/ru/profile/edit",
      component: _9b53d4cc,
      name: "profile-edit___ru"
    }, {
      path: "/profile/legal-documents",
      component: _f856df78,
      name: "profile-legal-documents___az"
    }, {
      path: "/ru/profile/legal-documents",
      component: _f856df78,
      name: "profile-legal-documents___ru"
    }, {
      path: "/profile/my-loan",
      component: _2bf9a991,
      name: "profile-my-loan___az"
    }, {
      path: "/ru/profile/my-loan",
      component: _2bf9a991,
      name: "profile-my-loan___ru"
    }, {
      path: "/profile/no-loan",
      component: _35fff11c,
      name: "profile-no-loan___az"
    }, {
      path: "/ru/profile/no-loan",
      component: _35fff11c,
      name: "profile-no-loan___ru"
    }, {
      path: "/registration/step1",
      component: _80e6780e,
      name: "registration-step1___az"
    }, {
      path: "/ru/registration/step1",
      component: _80e6780e,
      name: "registration-step1___ru"
    }, {
      path: "/registration/step2",
      component: _80ca490c,
      name: "registration-step2___az"
    }, {
      path: "/ru/registration/step2",
      component: _80ca490c,
      name: "registration-step2___ru"
    }, {
      path: "/registration/step3",
      component: _80ae1a0a,
      name: "registration-step3___az"
    }, {
      path: "/ru/registration/step3",
      component: _80ae1a0a,
      name: "registration-step3___ru"
    }, {
      path: "/registration/step4",
      component: _8091eb08,
      name: "registration-step4___az"
    }, {
      path: "/ru/registration/step4",
      component: _8091eb08,
      name: "registration-step4___ru"
    }, {
      path: "/registration/upload",
      component: _7ee082c6,
      name: "registration-upload___az"
    }, {
      path: "/ru/registration/upload",
      component: _7ee082c6,
      name: "registration-upload___ru"
    }, {
      path: "/recover/:slug",
      component: _36452c25,
      name: "recover-slug___az"
    }, {
      path: "/ru/recover/:slug",
      component: _36452c25,
      name: "recover-slug___ru"
    }, {
      path: "/special-campaign/:slug?",
      component: _0745b249,
      name: "special-campaign-slug___az"
    }, {
      path: "/ru/special-campaign/:slug?",
      component: _0745b249,
      name: "special-campaign-slug___ru"
    }, {
      path: "/",
      component: _2dfb1658,
      name: "index___az"
    }, {
      path: "/ru/",
      component: _2dfb1658,
      name: "index___ru"
    }, {
      path: "/hesab/payment",
      component: _36f9fd41,
      name: "hesab-payment___az"
    }, {
      path: "/ru/hesab/payment",
      component: _36f9fd41,
      name: "hesab-payment___ru"
    }, {
      path: "/epoint/payment",
      component: _145528fa,
      name: "epoint-payment___az"
    }, {
      path: "/ru/epoint/payment",
      component: _145528fa,
      name: "epoint-payment___ru"
    }, {
      path: "/payment/accepted",
      component: _013f1734,
      name: "payment-accepted___az"
    }, {
      path: "/ru/payment/accepted",
      component: _013f1734,
      name: "payment-accepted___ru"
    }, {
      path: "/payment/rejected",
      component: _1388a5bd,
      name: "payment-rejected___az"
    }, {
      path: "/ru/payment/rejected",
      component: _1388a5bd,
      name: "payment-rejected___ru"
    }, {
      path: "/flow",
      component: _59ba53f2,
      name: "flow___az"
    }, {
      path: "/ru/flow",
      component: _59ba53f2,
      name: "flow___ru"
    }, {
      path: "/admin",
      component: _943633aa,
      name: "admin___az"
    }, {
      path: "/ru/admin",
      component: _943633aa,
      name: "admin___ru"
    }, {
      path: "/admin/router",
      component: _ae311c12,
      name: "admin-router___az"
    }, {
      path: "/ru/admin/router",
      component: _ae311c12,
      name: "admin-router___ru"
    }],

    fallback: false
  })
}
